import { Trash } from 'phosphor-react'
import PropTypes from 'prop-types'
import { Component, Fragment, default as React } from 'react'
import { connect } from 'react-redux'
import { deleteDomEnvio, getDomEnvio, newDomEnvio } from '../../actions/domiciliosEnvio'
import { getEstados } from '../../actions/estados'
import { createMessage } from '../../actions/messages'
import { getProvincias } from '../../actions/provincias'
import i18n from '../../lang/idiomas'
import Spinner from '../layout/Spinner'

export class DomiciliosEnvioModif extends Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
    }

    static propTypes = {
        getDomEnvio: PropTypes.func.isRequired,
        domicilios_envio: PropTypes.array.isRequired,
        estado: PropTypes.object,
    }

    state = {
        domicilio: {
            nombre: '',
            direccion: '',
            estado: '',
            provincia: '',
            localidad: '',
            cod_postal: '',
            telefono: '',
        },
        dropdown: false,
        index: null,
        errors: {
            nombre: false,
            direccion: false,
            estado: false,
            provincia: false,
            localidad: false,
            cod_postal: false,
            telefono: false,
        },
    }

    componentDidMount() {
        this.props.getDomEnvio()
        this.props.getEstados()

        if (this.props.domicilios_envio) {
            this.props.domicilios_envio.forEach((dom, index) => {
                console.log(`Domicilio ${index + 1}:`, dom.nombre)
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.dropdown && this.state.dropdown) {
            // El formulario acaba de mostrarse
            if (this.formRef.current) {
                this.formRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest',
                })
            }
        }
    }

    onChange = e => {
        var updatedDomicilio = this.state.domicilio
        updatedDomicilio = {
            ...this.state.domicilio,
            [e.target.name]: e.target.value,
        }
        this.setState({ domicilio: updatedDomicilio })
        if (e.target.name === 'estado') {
            this.props.getProvincias(e.target.value)
        }
    }

    openModal = index => {
        // this.setState({ domicilio: null, dropdown: false, index: null })
        this.props.getEstados()
        // const direccion = this.props.domicilios_envio[index]
        // this.props.getProvincias(direccion.estado)
        const domicilio = {
            nombre: '',
            direccion: '',
            estado: '',
            provincia: '',
            localidad: '',
            cod_postal: '',
        }

        this.setState({
            domicilio,
            dropdown: true,
            index: index,
            errors: {
                nombre: false,
                direccion: false,
                estado: false,
                provincia: false,
                localidad: false,
                cod_postal: false,
                telefono: false,
            },
        })
    }

    closeModal = () => {
        this.setState({
            domicilio: {
                nombre: '',
                direccion: '',
                estado: '',
                provincia: '',
                localidad: '',
                cod_postal: '',
                telefono: '',
            },
            dropdown: false,
            index: null,
            errors: {
                nombre: false,
                direccion: false,
                estado: false,
                provincia: false,
                localidad: false,
                cod_postal: false,
                telefono: false,
            },
        })
    }

    guardarDomicilio = () => {
        let raiseError = false
        this.setState({
            errors: {
                nombre: !this.state.domicilio.nombre || this.state.domicilio.nombre === '',
                direccion: !this.state.domicilio.direccion || this.state.domicilio.direccion === '',
                estado: !this.state.domicilio.estado || this.state.domicilio.estado === '',
                provincia: !this.state.domicilio.provincia || this.state.domicilio.provincia === '',
                localidad: !this.state.domicilio.localidad || this.state.domicilio.localidad === '',
                cod_postal: !this.state.domicilio.cod_postal || this.state.domicilio.cod_postal === '',
                //telefono: !this.state.domicilio.telefono || this.state.domicilio.telefono === '',
            },
        })
        if (!this.state.domicilio.nombre || this.state.domicilio.nombre === '') {
            raiseError = true
        }
        if (!this.state.domicilio.direccion || this.state.domicilio.direccion === '') {
            raiseError = true
        }
        if (!this.state.domicilio.estado || this.state.domicilio.estado === '') {
            raiseError = true
        }
        if (!this.state.domicilio.provincia || this.state.domicilio.provincia === '') {
            raiseError = true
        }
        if (!this.state.domicilio.localidad || this.state.domicilio.localidad === '') {
            raiseError = true
        }
        if (!this.state.domicilio.cod_postal || this.state.domicilio.cod_postal === '') {
            raiseError = true
        }
        /*if (!this.state.domicilio.telefono || this.state.domicilio.telefono === '') {
            raiseError = true
        }*/
        if (raiseError) {
            this.props.createMessage(i18n.t('general.nocamobl'), 'error')
            return false
        }
        this.props.newDomEnvio(this.state?.domicilio)
        this.closeModal()
    }

    render() {
        return (
            <Fragment>
                {this.props.isLoading ? (
                    <Spinner showSpinner={this.props.isLoading} />
                ) : (
                    <div className='tt-shopcart-box domicilio-envio-box'>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <h3 className='tt-title w-100'>{i18n.t('domicilios.titdomen').toUpperCase()}</h3>
                            <div className='btn-box d-flex justify-content-end'>
                                <button
                                    className='btn btn-border'
                                    style={{ maxWidth: 'fit-content' }}
                                    type='button'
                                    onClick={e => {
                                        this.openModal()
                                    }}>
                                    {i18n.t('domicilios.adddomen')}
                                </button>
                            </div>
                        </div>
                        <div style={{ overflowX: 'auto', justifyItems: 'stretch' }}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>{i18n.t('domicilios.nombre')}</th>
                                        <th>{i18n.t('domicilios.direc')}</th>
                                        <th>{i18n.t('domicilios.local')}</th>
                                        <th>{i18n.t('domicilios.estdomay')}</th>
                                        <th>{i18n.t('domicilios.prov')}</th>
                                        <th>{i18n.t('domicilios.codpstal')}</th>
                                        <th>{i18n.t('general.actions').toUpperCase()}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.domicilios_envio.length > 0 &&
                                        this.props.domicilios_envio.map((dom, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{dom.nombre}</td>
                                                    <td>{dom.direccion}</td>
                                                    <td>{dom.localidad}</td>
                                                    <td>{dom.estado}</td>
                                                    <td>
                                                        {dom.d_provincia ||
                                                            this.props.provincias.find(
                                                                prov =>
                                                                    prov.estado === dom.estado && prov.provincia === dom.provincia,
                                                            )?.nombre ||
                                                            dom.provincia}
                                                    </td>
                                                    <td>{dom.cod_postal}</td>
                                                    <td>
                                                        <div className='btn-box'>
                                                            <button
                                                                className='btn btn-border'
                                                                style={{ maxWidth: 'fit-content' }}
                                                                type='button'
                                                                onClick={e => {
                                                                    this.props.deleteDomEnvio(dom.id)
                                                                }}
                                                                disabled={this.props.domicilios_envio.length <= 1}>
                                                                <Trash size={20} />
                                                                {/*i18n.t('general.eliminar')*/}
                                                            </button>
                                                        </div>
                                                    </td>
                                                    {/*<td>
                                                        <div className='btn-box'>
                                                            <button
                                                                className='btn btn-border'
                                                                style={{ maxWidth: 'fit-content' }}
                                                                type='button'
                                                                onClick={e => {
                                                                    this.openModal(index)
                                                                }}>
                                                                {i18n.t('general.editar')}
                                                            </button>
                                                        </div>
                                                    </td>*/}
                                                </tr>
                                            )
                                        })}
                                </tbody>
                            </table>
                        </div>
                        {this.state.dropdown /*&& this.props.domicilios_envio.length > this.state.index */ && (
                            <form
                                id='nuevo_domicilio_envio_form'
                                className='form-default'
                                ref={this.formRef}>
                                <div className='row'>
                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                            <label
                                                htmlFor={`input_nombre_${this.state.index}`}
                                                className={this.state.errors.nombre ? 'label-input-has-errors' : ''}>
                                                {i18n.t('domicilios.nombre')} <sup>*</sup>
                                            </label>
                                            <input
                                                type='text'
                                                id={`input_nombre_${this.state.index}`}
                                                name='nombre'
                                                value={this.state.domicilio?.nombre}
                                                className={
                                                    this.state.errors.nombre
                                                        ? 'form-control input-has-errors'
                                                        : 'form-control'
                                                }
                                                placeholder={i18n.t('usuarios.unommin')}
                                                onChange={e => {
                                                    this.onChange(e)
                                                }}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                            <label
                                                htmlFor={`input_telefono_${this.state.index}`}
                                                className={this.state.errors.telefono ? 'label-input-has-errors' : ''}>
                                                {i18n.t('usuarios.utel').toUpperCase()}
                                            </label>
                                            <input
                                                type='text'
                                                id={`input_telefono_${this.state.index}`}
                                                name='telefono'
                                                value={this.state.domicilio?.telefono}
                                                className='form-control'
                                                placeholder={i18n.t('usuarios.utel')}
                                                onChange={e => {
                                                    this.onChange(e)
                                                }}
                                            />
                                            <input
                                                type='hidden'
                                                id={`input_tipo_portes_${this.state.index}`}
                                                name='tipo_portes'
                                                value={
                                                    this.state.domicilio?.tipo_portes &&
                                                        this.state.domicilio?.tipo_portes === 'S'
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-12 col-md-12 col-lg-12'>
                                        <div className='form-group'>
                                            <label
                                                htmlFor={`input_direccion_${this.state.index}`}
                                                className={this.state.errors.direccion ? 'label-input-has-errors' : ''}>
                                                {i18n.t('domicilios.direc')} <sup>*</sup>
                                            </label>
                                            <input
                                                type='text'
                                                id={`input_direccion_${this.state.index}`}
                                                name='direccion'
                                                value={this.state.domicilio?.direccion}
                                                className='form-control'
                                                placeholder={
                                                    i18n.t('domicilios.direc').split('')[0] +
                                                    i18n.t('domicilios.direc').split('').slice(1).join('').toLowerCase()
                                                }
                                                onChange={e => {
                                                    this.onChange(e)
                                                }}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                            <label
                                                htmlFor={`input_estado_${this.state.index}`}
                                                className={this.state.errors.estado ? 'label-input-has-errors' : ''}>
                                                {i18n.t('domicilios.estdomay')} <sup>*</sup>
                                            </label>
                                            <select
                                                className='form-control'
                                                name='estado'
                                                id={`input_estado_${this.state.index}`}
                                                onChange={e => {
                                                    this.onChange(e)
                                                }}
                                                value={this.state.domicilio?.estado}
                                                placeholder='Estado'
                                                required={true}>
                                                <option value=''>{i18n.t('domicilios.estdomin')}</option>
                                                {this.props.estados && this.props.estados.length > 0
                                                    ? this.props.estados
                                                        .slice()
                                                        .sort((a, b) => {
                                                            if (a.nombre === 'ESPAÑA') return -1
                                                            if (b.nombre === 'ESPAÑA') return 1
                                                            return a.nombre.localeCompare(b.nombre)
                                                        })
                                                        .map((estado, index) => {
                                                            let est = this.state.domicilio?.estado
                                                                ? this.state.domicilio?.estado
                                                                : ''

                                                            if (estado.codigo === est) {
                                                                return (
                                                                    <option
                                                                        key={index}
                                                                        value={estado.codigo}
                                                                        selected>
                                                                        {estado.nombre}
                                                                    </option>
                                                                )
                                                            } else {
                                                                return (
                                                                    <option
                                                                        key={index}
                                                                        value={estado.codigo}>
                                                                        {estado.nombre}
                                                                    </option>
                                                                )
                                                            }
                                                        })
                                                    : ''}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                            <label
                                                htmlFor={`input_provincia_${this.state.index}`}
                                                className={this.state.errors.provincia ? 'label-input-has-errors' : ''}>
                                                {i18n.t('domicilios.prov')} <sup>*</sup>
                                            </label>
                                            <select
                                                className='form-control'
                                                name='provincia'
                                                id={`input_provincia_${this.state.index}`}
                                                onChange={e => {
                                                    this.onChange(e)
                                                }}
                                                value={this.state.domicilio?.provincia}
                                                placeholder='Provincia'
                                                required={true}>
                                                <option value=''>{i18n.t('domicilios.provmin')}</option>
                                                {this.props.provincias && this.props.provincias.length > 0
                                                    ? this.props.provincias
                                                        .slice()
                                                        .sort((a, b) => a.nombre.localeCompare(b.nombre))
                                                        .map((provincia, index) => {
                                                            let prov = this.state.domicilio?.provincia
                                                                ? this.state.domicilio?.provincia
                                                                : ''

                                                            if (provincia.provincia === prov) {
                                                                return (
                                                                    <option
                                                                        key={index}
                                                                        value={provincia.provincia}
                                                                        selected>
                                                                        {provincia.nombre}
                                                                    </option>
                                                                )
                                                            } else {
                                                                return (
                                                                    <option
                                                                        key={index}
                                                                        value={provincia.provincia}>
                                                                        {provincia.nombre}
                                                                    </option>
                                                                )
                                                            }
                                                        })
                                                    : ''}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                            <label
                                                htmlFor={`input_localidad_${this.state.index}`}
                                                className={this.state.errors.localidad ? 'label-input-has-errors' : ''}>
                                                {i18n.t('domicilios.local')} <sup>*</sup>
                                            </label>
                                            <input
                                                type='text'
                                                name='localidad'
                                                id={`input_localidad_${this.state.index}`}
                                                value={this.state.domicilio?.localidad || ''}
                                                className='form-control'
                                                placeholder={i18n.t('domicilios.localmin')}
                                                onChange={e => {
                                                    this.onChange(e)
                                                }}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                        <div className='form-group'>
                                            <label
                                                htmlFor={`input_cod_postal_${this.state.index}`}
                                                className={this.state.errors.cod_postal ? 'label-input-has-errors' : ''}>
                                                {i18n.t('domicilios.codpstal')} <sup>*</sup>
                                            </label>
                                            <input
                                                type='text'
                                                id={`input_cod_postal_${this.state.index}`}
                                                name='cod_postal'
                                                value={this.state.domicilio?.cod_postal}
                                                className='form-control'
                                                placeholder={i18n.t('domicilios.codposmi')}
                                                onChange={e => {
                                                    this.onChange(e)
                                                }}
                                                required={true}
                                            />
                                            <input
                                                type='hidden'
                                                id={`input_tipo_portes_${this.state.index}`}
                                                name='tipo_portes'
                                                value={
                                                    this.state.domicilio?.tipo_portes &&
                                                        this.state.domicilio?.tipo_portes === 'S'
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-auto'>
                                        <div
                                            className='form-group btn-box'
                                            style={{ display: 'flex', gap: '1rem' }}>
                                            <button
                                                className='btn btn-border'
                                                type='button'
                                                onClick={e => {
                                                    this.guardarDomicilio()
                                                }}>
                                                {i18n.t('general.guarcamb')}
                                            </button>
                                            <button
                                                className='btn btn-border'
                                                type='button'
                                                onClick={e => {
                                                    this.closeModal()
                                                }}>
                                                {i18n.t('general.cancelar')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                )
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    domicilios_envio: state.domiciliosEnvio.domicilios_envio,
    isLoading: state.domiciliosEnvio.isLoading,
    provincias: state.provincias.provincias,
    estados: state.estados.estados,
})

export default connect(mapStateToProps, {
    getDomEnvio,
    getEstados,
    getProvincias,
    deleteDomEnvio,
    newDomEnvio,
    createMessage,
})(DomiciliosEnvioModif)